//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { Dialog, RadioGroup, Radio, Input } from 'element-ui';
import * as api from '~/api/index';
import MessageDialog from '~/components/public/violation/message-dialog.vue';
Dialog.props.lockScroll.default = false; // 解决dialog出现时页面抖动的问题
export default {
  components: {
    ElDialog: Dialog,
    ElRadioGroup: RadioGroup,
    ElRadio: Radio,
    ElInput: Input,
    MessageDialog,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    // true:申诉 false:投诉
    isAppeal: {
      type: Boolean,
      default: false,
    },
    // 文本框最大输入字数
    maxlength: {
      type: Number,
      default: 50,
    },
    query: {
      type: Object,
      default() {
        return {
          source: 'dynamic',
          userId: null,
          id: null, // 内容id/消息id
          type: 'content', // user｜content
        };
      },
    },
  },
  data() {
    return {
      picList: [],
      reason: '', // 被选中的违规原因
      violationList: [], // 违规列表
      violationTypeId: null,
      violationDescription: '', // 说明
      violationDetail: {}, // 被投诉详情
      messageData: {
        show: false,
        content: '提交成功',
      },
    };
  },
  computed: {
    ...mapGetters('user', ['userId']),
    uploadImgRef() {
      return `doUploadImg${this.query.id || ''}`;
    },
    canSubmit() {
      if (this.isAppeal) {
        return !!this.violationDescription;
      }
      const result = this.violationList.some(item => {
        if (
          (item.reason === this.reason &&
            item.required &&
            this.violationDescription) ||
          (item.reason === this.reason && !item.required)
        ) {
          return true;
        }
        return false;
      });
      return result;
    },
    showRequired() {
      const result = this.violationList.some(item => {
        if (item.reason === this.reason && item.required) {
          return true;
        }
        return false;
      });
      return result;
    },
  },
  mounted() {
    this.getViolationData();
  },
  methods: {
    /**
     * @description 选中的内容违规id
     */
    changeRadio(id) {
      this.violationTypeId = id;
    },
    /**
     * @description 获取违规数据(type=content,内容违规， type=user， 用户违规)
     */
    async getViolationData() {
      const { type, id } = this.query;
      if (this.isAppeal) {
        const res = await this.$axios(api.getViolationDetail(type, id));
        this.violationDetail = res.result;
      } else {
        const res = await this.$axios(api.getViolationList(type));
        this.violationList = res.result || [];
      }
    },
    /**
     * @description 点击添加图片
     */
    fakeUploadImg() {
      this.$refs[this.uploadImgRef].click();
    },
    /**
     * @description 上传图片
     */
    async uploadImg() {
      if (this.picList.length >= 3) {
        this.showMessage('不能超过3张图片', 'warning');
        return;
      }
      const file = document.querySelector(`#${this.uploadImgRef}`).files[0];
      if (!file) return; // 防止--在至少上传过一次图片后，再次上传时点击取消是跳500页面
      if (/(jpeg|png|gif){1}/gi.test(file.type) && file.size < 3000000) {
        const fileData = new FormData();
        fileData.append('file', file, file.name);
        const res = await this.$axios(api.uploadActivityImage(fileData));
        this.picList.push({
          imgurl: res.result,
        });
      } else {
        this.showMessage('图片大小超过最大限制', 'warning');
      }
    },
    /**
     * @description 删除图片
     */
    deletePic(idx) {
      this.picList.splice(idx, 1);
    },
    /**
     * @description 关闭弹窗
     */
    cancel() {
      this.$emit('cancel');
      this.clearData();
    },
    /**
     * @description 提交
     */
    async submit() {
      // 节流 防抖
      if (!this.canSubmit) return;
      const imageUrls =
        this.picList.map(picitem => {
          return picitem.imgurl;
        }) || [];
      let res;
      if (this.isAppeal) {
        // 申诉
        const { violationTypeId, violationDescription, source, type, refId } =
          this.violationDetail;
        res = await this.$axios(
          api.toUserAppeal({
            type,
            refId,
            source,
            imageUrls,
            violationTypeId, // 被投诉的原因id
            reason: violationDescription, // 被投诉原因
            description: this.violationDescription, // 申诉说明
          })
        );
      } else {
        const { source, userId, id, type } = this.query;
        // 投诉
        res = await this.$axios(
          api.toUserComplain(type, {
            refId: id,
            userId,
            source,
            imageUrls,
            violationTypeId: this.violationTypeId,
            violationDescription: this.violationDescription, // 投诉说明
          })
        );
      }
      if (res.statusCode === 200) {
        this.messageData.show = true;
        this.messageData.content = '提交成功';
      }
    },
    closeDialog() {
      this.messageData.show = false;
      this.cancel();
    },
    /**
     * @description 清除弹窗数据
     */
    clearData() {
      this.reason = '';
      this.picList = [];
      this.violationTypeId = null;
      this.violationDescription = '';
    },
  },
};
